import { KeyValuePipe } from '@angular/common';
import { Component, linkedSignal, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TuiDialogContext, TuiScrollbar } from '@taiga-ui/core';
import { TuiInputModule } from '@taiga-ui/legacy';
import { injectContext } from '@taiga-ui/polymorpheus';
import { UserFeatureDTO } from 'src/app/map/features/layers/layers.component';
import { OverflowPaddingDirective } from 'src/app/shared/directives/overflow-padding.directive';
import { UpdateUserFeature } from '../../data-access/feature-layers.service';
import { Prettify } from 'src/app/shared/features/esk-tool/util';

@Component({
  selector: 'app-update-feature-attributes',
  imports: [
    TuiScrollbar,
    OverflowPaddingDirective,
    FormsModule,
    KeyValuePipe,
    TuiInputModule,
  ],
  template: `
    <tui-input
      appearance=""
      class="flex-grow !shadow-none"
      [ngModel]="feature().name"
      (ngModelChange)="setProperty({name: $event})"
      [ngModelOptions]="{ standalone: true }"
    >
      Name
      <input tuiTextfieldLegacy type="text" />
    </tui-input>

    <tui-scrollbar>
      <div overflowPadding class="max-h-[400px]">
        @for(attribute of feature().attributes | keyvalue; track attribute.key)
        {
        <div
          class="flex items-center justify-start py-2.5 border-b border-gray-200"
        >
          <div class="flex-1 flex items-center gap-2">
            <tui-input
              class="flex-grow"
              [ngModel]="attribute.key"
              disabled
              [ngModelOptions]="{ standalone: true }"
            >
              Attribute
              <input tuiTextfieldLegacy type="text" />
            </tui-input>

            <tui-input
              class="flex-grow"
              [ngModel]="attribute.value"
              disabled
              [ngModelOptions]="{ standalone: true }"
            >
              Value
              <input tuiTextfieldLegacy type="text" />
            </tui-input>
          </div>
        </div>
        }
      </div>
    </tui-scrollbar>

    <div class="p-2 flex justify-end">
      <button
        class="bg-gray-300 hover:bg-gray-400 text-gray-700 py-2 px-4 rounded mr-2"
        (click)="onNoClick()"
      >
        Cancel
      </button>
      <button
        class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded disabled:bg-blue-300 disabled:cursor-not-allowed"
        (click)="onYesClick()"
      >
        Confirm
      </button>
    </div>
  `,
})
export class UpdateFeatureAttributesComponent {
  public readonly context =
    injectContext<
      TuiDialogContext<UpdateUserFeature, { feature: UserFeatureDTO }>
    >();

  feature = signal(this.context.data.feature);

  updateModel = linkedSignal<UpdateUserFeature>(() => {
    const { featureID } = this.feature();

    return { featureID, layersToDifferenceWith: [] };
  });

  setProperty(model: Prettify<Partial<Pick<UpdateUserFeature, 'name'>>>)
  {
    this.updateModel.update(val =>
      {
          return {...val, ...model}
    })
  }

  constructor() {}

  onNoClick(): void {
    this.context.$implicit.complete();
  }

  onYesClick(): void {
     this.context.completeWith(this.updateModel());
  }
}
